import { Logo } from '../shared/layout/Logo';
import { SidebarContent } from './components/SidebarContent';
import { SidebarHeader } from './components/SidebarHeader';
import { Sidebar } from './Sidebar';
import { SidebarToggle } from './components/SidebarToggle';
import { useLayout } from '@/hooks/useLayout';

interface SharedSidebarProps {
  children?: React.ReactNode;
}

export const SharedSidebar = ({ children }: SharedSidebarProps) => {
  const { sidebarCollapsed, toggleSidebar } = useLayout();

  return (
    <Sidebar collapsed={sidebarCollapsed}>
      <SidebarHeader>
        <Logo collapsed={sidebarCollapsed} />
      </SidebarHeader>
      <SidebarContent>
        {children}
        <SidebarToggle
          collapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
        />
      </SidebarContent>
    </Sidebar>
  );
};
